import {ReactElement, useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import SimpleToast from '@frontend/ui-kit/Components/Toast';
import {hideToast, getToastState} from '../../../slices/shared';
import {AppDispatch} from '../../../store';

const Toast = (): ReactElement => {
    const dispatch = useDispatch<AppDispatch>();
    const {isVisible, content, visibilityTime} = useSelector(getToastState);
    const timeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    useEffect(() => {
        if (isVisible && visibilityTime) {
            clearTimeout(timeout.current);
            timeout.current = setTimeout(() => dispatch(hideToast()), visibilityTime);
        }
    }, [dispatch, isVisible, content, visibilityTime]);

    return <SimpleToast data-testid='toast' content={content} isVisible={isVisible}/>;
};

export {Toast as TestableToast};
export default Toast;
